import {RootState} from '../rootReducer';

export const modelDisplayViewersSelector = (state: RootState) => state.modelDisplayViewers;
